import React, { useMemo } from 'react';

import { AnalyticsContext } from '@atlaskit/analytics-next';

import { useOnDismissDialog } from '../../../analytics/use-on-dismiss-dialog';
import { useEditionAwareness } from '../../../services/edition-awareness-context';
import { getHamsKey } from '../../../services/product-to-hams-key';
import { ModalEntryPoint } from '../shared/modal-entry-point';

import { PlanSelectionPageModalType } from './dialog';
import { DIALOG_CONFIG } from './dialog-config';
import { entryPoint } from './entrypoint';

export function PlanSelectionPageDialog({ type }: { type: PlanSelectionPageModalType }) {
	const { cloudId, product } = useEditionAwareness();

	const getOfferingName = (OfferingType: PlanSelectionPageModalType) => {
		switch (OfferingType) {
			case 'twc':
				return '';
			case 'jira-reverse-trial':
				return 'jira-software';
			default:
				return '';
		}
	};

	const entryPointParams = useMemo(
		() => ({
			cloudId,
			hamsProductKey: getHamsKey(product),
			offeringName: getOfferingName(type),
		}),
		[cloudId, product, type],
	);

	const onClose = useOnDismissDialog({ ...DIALOG_CONFIG });

	const entryPointProps = useMemo(() => ({ onClose, type }), [onClose, type]);

	const modalProps = useMemo(
		() => ({
			width: '968px',
			height: '808px',
			autoFocus: false,
			shouldScrollInViewport: false,
			shouldCloseOnEscape: true,
		}),
		[],
	);

	return (
		<AnalyticsContext data={DIALOG_CONFIG}>
			<ModalEntryPoint
				entryPointProps={entryPointProps}
				entryPoint={entryPoint}
				entryPointParams={entryPointParams}
				modalProps={modalProps}
			/>
		</AnalyticsContext>
	);
}
